import React, { StrictMode } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider } from 'styled-components'

import Routes from './modules/Routes'
import Loading from './shared/components/Loading'
import { persistor, store } from './shared/store'
import { GlobalStyle } from './shared/styles/globalStyle'
import { theme } from './shared/styles/theme'

function App() {
	return (
		<StrictMode>
			<GlobalStyle />
			<Provider store={store}>
				<PersistGate loading={<Loading />} persistor={persistor}>
					<ThemeProvider theme={theme}>
						<Routes />
					</ThemeProvider>
				</PersistGate>
			</Provider>
		</StrictMode>
	)
}

export default App
